export interface ITimelinePoint {
  month: string;
  value: number;
  previous_year?: number | null;
}

// 把 mom（百分比，如 3.529412 表示 +3.53%）格式化为 '+3.53%' / '-1.20%'
export const formatMoM = (mom: any): string => {
  if (mom === null || mom === undefined || isNaN(Number(mom))) {
    return '-';
  }
  const num = Number(mom);
  return `${num.toFixed(2)}%`;
};

// 简单货币缩写：1.23B / 4.56M / 7.89K
export const formatShortMoney = (num: any): string => {
  if (num === null || num === undefined || isNaN(Number(num))) {
    return '-';
  }
  const value = Number(num);
  const abs = Math.abs(value);
  if (abs >= 1_000_000_000) return `${(value / 1_000_000_000).toFixed(1)}B`;
  if (abs >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (abs >= 1_000) return `${(value / 1_000).toFixed(1)}K`;
  return `${value}`;
};

// kpi_completion: 83.33 → '83.33%'
export const formatPercent = (num: any): string => {
  if (num === null || num === undefined || isNaN(Number(num))) {
    return '-';
  }
  return `${Number(num).toFixed(1)}%`;
};

// 根据 timeline: [{month, value}, ...] 构造 LineChart 配置
export const buildTrendData = (
  timeline: Array<ITimelinePoint> | undefined,
  metricKey: string,
) => {
  const safeTimeline = Array.isArray(timeline) ? timeline : [];
  const xAxisData = safeTimeline.map((p) => p?.month);
  const thisMonthSeriesData = safeTimeline.map((p) => {
    if (p?.value === null || p?.value === undefined || isNaN(Number(p?.value))) {
      return null;
    }
    return Number(p.value);
  });
  const previousYearSeriesData = safeTimeline.map((p) => {
    const previousYear = p?.previous_year;
    if (previousYear === null || previousYear === undefined || isNaN(Number(previousYear))) {
      return null;
    }
    return Number(previousYear);
  });

  return {
    xAxisData,
    metrics_name: metricKey,
    series: [
      {
        name: 'This Month',
        type: 'line',
        color: '#7F6FF1',
        showSymbol: false,
        itemStyle: {
          color: '#7F6FF1',
        },
        lineStyle: {
          type: 'solid',
          color: '#7F6FF1',
        },
        areaStyle: {
          opacity: 0.25,
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: '#7F6FF1' },
              { offset: 1, color: '#FFF' },
            ],
          },
        },
        data: thisMonthSeriesData,
      },
      {
        name: 'Same Month Last Year',
        type: 'line',
        color: '#74CDF6',
        showSymbol: true,
        itemStyle: {
          color: '#74CDF6',
        },
        lineStyle: {
          type: 'dotted',
          color: '#74CDF6',
        },
        areaStyle: {
          opacity: 0.25,
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: '#74CDF6' },
              { offset: 1, color: '#FFF' },
            ],
          },
        },
        data: previousYearSeriesData,
      },
    ],
  };
};

// gross_revenue 主数值取 monthly_actual；mau/avg_dau 取 value
export const getMetricNumericValue = (
  metricKey: 'gross_revenue' | 'mau' | 'avg_dau',
  project: any,
): number | null => {
  if (metricKey === 'gross_revenue') {
    const v = project?.gross_revenue?.monthly_actual;
    return v === null || v === undefined ? null : Number(v);
  }
  if (metricKey === 'mau') {
    const v = project?.mau?.value;
    return v === null || v === undefined ? null : Number(v);
  }
  const v = project?.avg_dau?.value;
  return v === null || v === undefined ? null : Number(v);
};
